/**
 * ROUTE GUARD - TEMPORARY SUPABASE IMPLEMENTATION
 * 
 * This component protects routes from unauthenticated access.
 * When migrating to OnSiteX Core SSO, update this file to validate
 * OnSiteX Core tokens instead of Supabase sessions.
 */

import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { supabase } from '../lib/supabase';

const RequireAuth = ({ children }) => {
  const { user, loading, userProfile, profileLoading } = useAuth();
  const navigate = useNavigate();

  const isInactive = userProfile && userProfile?.is_active === false;

  useEffect(() => {
    if (isInactive) {
      supabase?.auth?.signOut()?.then(() => {
        navigate('/login', { replace: true, state: { reason: 'account_inactive' } });
      });
    }
  }, [isInactive, navigate]);

  if (loading || profileLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="inline-block w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
          <p className="mt-4 text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (isInactive) {
    return null;
  }

  return children;
};

export default RequireAuth;